"use strict";

exports.__esModule = true;

var _frameStorage = _interopRequireDefault(require("./strategies/frame-storage"));

exports.FrameStorageStrategy = _frameStorage["default"];

var _constants = require("./utils/constants");

exports.NOT_FOUND = _constants.NOT_FOUND;

var _baseStorage = _interopRequireDefault(require("./base-storage"));

exports.BaseStorage = _baseStorage["default"];

var _dataCapsule = _interopRequireDefault(require("./data-capsule"));

exports.DataCapsule = _dataCapsule["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }